import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '@shared/lib/utils';

const buttonVariants = cva(
  'inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-lg px-4 py-3 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        success: 'bg-status-success/90 text-white hover:bg-status-success',
        danger: 'bg-status-live/90 text-white hover:bg-status-live',
        neutral: 'border border-surface-border bg-surface-2 text-text-primary hover:bg-surface-3',
        accent: 'bg-accent text-white hover:bg-accent-hover',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  },
);

interface ActionButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  icon?: ReactNode;
  asChild?: boolean;
}

export function ActionButton({
  icon,
  variant = 'neutral',
  asChild = false,
  className = '',
  children,
  ...rest
}: ActionButtonProps) {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp type="button" className={cn(buttonVariants({ variant }), className)} {...rest}>
      {icon}
      {children}
    </Comp>
  );
}
